var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{attrs:{"id":_vm.field.id}},[_vm._v(_vm._s(_vm.field.label[_vm.currentLanguage]))]),_vm._v(" "),(_vm.field.description[_vm.currentLanguage])?_c('p',{staticClass:"small",domProps:{"innerHTML":_vm._s(_vm.field.description[_vm.currentLanguage])}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0ec2880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/step.vue
// module id = null
// module chunks = 